export default __webpack_public_path__ + "static/media/doc.a385eefa.svg";